import { Ability, AbilityBuilder } from "@casl/ability";
import { abilitiesPlugin } from "@casl/vue";
import "swiper/swiper-bundle.css";
import VCalendar from "v-calendar";
import vco from "v-click-outside";
import Vue from "vue";
import VueAwesomeSwiper from "vue-awesome-swiper";
import VueClipboard from "vue-clipboard2";
import Croppa from "vue-croppa";
import "vue-croppa/dist/vue-croppa.css";
import VueDragscroll from "vue-dragscroll";
import FlagIcon from "vue-flag-icon";
import GSignInButton from "vue-google-signin-button";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import vueSocketIO from "vue-socket.io";
import VueTheMask from "vue-the-mask";
import VueYoutube from "vue-youtube";
import App from "./App.vue";
import store from "./controller/baseController";
//global Function and Enums Data
import VueMixinDataFunction from "./function/vueMixinDataFunction";
//global component
import { ApmVuePlugin } from "@elastic/apm-rum-vue";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "@fortawesome/fontawesome-pro/css/all.min.css";
import "katex/dist/katex.min.css";
import PortalVue from "portal-vue";
import { default as msalPlugin } from "vue-msal-browser";
import pkg from "../package.json";
import appInsights from "./config/appInsights";
import "./globalComponentRegistration";
import helper from "./helper/mainHelper";
import i18n from "./locales/i18n";
import router from "./router";
import { Mixpanel } from "./service/analytics/mixpanel";

router.beforeEach(async (to, from, next) => {
  await helper.CheckAssetTokenValidBeforeRouterChange(from.name);
  helper.AuthorizeModels(to.name);
  helper.SetLastUrl(to);
  helper.SetMetaTagFromRouter(to);
  helper.CheckCanNext(next);
});

const msalConfig = {
  auth: {
    tenant: process.env.VUE_APP_Microsoft_Tenant,
    clientId: process.env.VUE_APP_Microsoft_Client,
    authority: `https://login.microsoftonline.com/common`,
    redirectUri: process.env.VUE_APP_PeakAccount,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
    secureCookies: false,
    claimsBasedCachingEnabled: false,
  },
};

Vue.use(PortalVue);

Vue.use(msalPlugin, msalConfig);

Vue.use(VueTheMask);

Vue.use(FlagIcon);

Vue.use(VueClipboard);

Vue.use(VueYoutube);

Vue.use(VCalendar, {
  componentPrefix: "v",
  backgroundColor: "#282C34",
  border: "1px solid #dadada",
});

Vue.use(vco);

Vue.use(VueAwesomeSwiper);

Vue.use(VueDragscroll);

Vue.use(GSignInButton);

Vue.component("Multiselect", Multiselect);

Vue.mixin(VueMixinDataFunction);

Vue.use(
  new vueSocketIO({
    debug: false,
    connection: process.env.VUE_APP_PeakNotification,
    vuex: {
      store,
      actionPrefix: "SOCKET_",
      mutationPrefix: "SOCKET_",
    },
    options: {
      autoConnect: false,
    },
  })
);

function defineAbilityFor() {
  const { can, cannot, build } = new AbilityBuilder(Ability);
  return build();
}
const ability = defineAbilityFor();

Vue.use(abilitiesPlugin, ability);

Vue.use(Croppa);

if (process.env.VUE_APP_ElasticApmEnabled == "true") {
  Vue.use(ApmVuePlugin, {
    router,
    config: {
      serverUrl: process.env.VUE_APP_ElasticApmServerUrl,
      serviceName: process.env.VUE_APP_ElasticApmServiceName,
      serviceVersion: pkg.version,
      environment: process.env.VUE_APP_ElasticApmEnvironment,
      breakdownMetrics: process.env.VUE_APP_ElasticApmBreakdownMetrics === "true",
      eventsLimit: Number(process.env.VUE_APP_ElasticApmEventsLimit),
      transactionSampleRate: Number(process.env.VUE_APP_ElasticApmTransactionSampleRate),
      apmRequest: (req) => {
        req.xhr.setRequestHeader("Authorization", `Bearer ${process.env.VUE_APP_ElasticApmSecretToken}`);
        return true;
      },
    },
  });
}

if (process.env.VUE_APP_ApplicationInsights_Enabled == "true") {
  appInsights.loadAppInsights();
}

Vue.config.productionTip = false;

router.onError((error) => {
  let regex = new RegExp(/Loading .* failed\./i);
  if (regex.test(error.message)) {
    window.location.href = `${window.location.origin}/update.html?v=${new Date().getTime()}`;
  }
});

Mixpanel.start();

const app = new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
